import type { MusicGenerationPrefs, MusicGraphicMode, RhythmReadingMethod } from '@interactive-room';

export type { MusicGenerationPrefs, MusicGraphicMode, RhythmReadingMethod } from '@interactive-room';

export const DEFAULT_MUSIC_AI_PREFS: MusicGenerationPrefs = {
  readingMethod: 'tradicional',
  graphicMode: 'symbols',
};

export const MUSIC_READING_METHOD_OPTIONS: Array<{
  id: RhythmReadingMethod;
  label: string;
  detail: string;
}> = [
  {
    id: 'tradicional',
    label: 'Tradicional',
    detail: 'Negra, Blanca, Corchea — sin sílabas impuestas',
  },
  {
    id: 'takadimi',
    label: 'Takadimi',
    detail: 'Ta, Ta-di, Ta-ka-di-mi',
  },
  {
    id: 'kodaly',
    label: 'Kodály',
    detail: 'Ta, ti-ti, ti-ki-ti-ki',
  },
];

export const MUSIC_GRAPHIC_MODE_OPTIONS: Array<{
  id: MusicGraphicMode;
  label: string;
  detail: string;
}> = [
  { id: 'symbols', label: 'Símbolos puros', detail: '♩ ♫ 𝅗𝅥 sin paréntesis' },
  { id: 'symbols-labels', label: 'Símbolos + etiqueta', detail: 'Figura + nombre breve al pie' },
];
